import React from 'react';

/**
 * Sync UA check for Instagram / Facebook in-app browsers.
 * Safe to call outside React (e.g. Firebase init).
 */
export function isInAppBrowser(userAgent = navigator.userAgent): boolean {
  const ua = userAgent.toLowerCase();
  return (
    ua.includes('instagram') ||
    ua.includes('fban') ||
    ua.includes('fbav') ||
    ua.includes('facebook')
  );
}

/**
 * Whether a Firebase sign-in failure should open the Twilio Verify fallback.
 * Offered in any browser (Firebase send failures otherwise dead-end the
 * login); skips user errors that Twilio would not help with.
 */
export function shouldOfferTwilioFallback(error: unknown): boolean {
  if (error && typeof error === 'object' && 'code' in error) {
    const { code } = error as { code: string };
    if (code === 'auth/invalid-phone-number') {
      return false;
    }
  }

  return true;
}

/**
 *
 * useDetectAndroidWebView
 *
 * @returns {boolean} isWebView
 */
export function useDetectAndroidWebView() {
  const isWebView = React.useMemo(() => {
    const { userAgent } = navigator;
    return userAgent.includes('wv') || userAgent.includes('WebView');
  }, []);

  return isWebView;
}

export function useDetectInAppBrowser() {
  return React.useMemo(() => isInAppBrowser(), []);
}
